'use client'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { MdOutlineCloudOff } from 'react-icons/md'

import { buildLocalePath } from '@/utils'

import { Button } from './button'

type Props = {
  reset?: () => void
}

export default function ServerError({ reset }: Props) {
  const { i18n, t } = useTranslation()

  return (
    <main className='grid min-h-[70vh] place-items-center px-6 py-16'>
      <div className='flex max-w-md flex-col items-center gap-6 text-center'>
        <div className='grid size-24 place-items-center rounded-full bg-secondary/10'>
          <MdOutlineCloudOff className='size-12 text-secondary' />
        </div>
        <div className='space-y-3'>
          <h1 className='text-3xl font-bold text-secondary'>{t('error.title')}</h1>
          <p className='text-muted-foreground'>{t('error.description')}</p>
        </div>
        <div className='flex flex-wrap justify-center gap-3'>
          {reset ? (
            <Button onClick={reset}>{t('error.retry')}</Button>
          ) : (
            <Button onClick={() => window.location.reload()}>{t('error.refresh')}</Button>
          )}
          <Button asChild variant='outline'>
            <Link href={buildLocalePath(i18n.language, '/')}>{t('error.home')}</Link>
          </Button>
        </div>
      </div>
    </main>
  )
}
